module.exports = __webpack_public_path__ + "static/media/img-4.89003813.jpg";